import { BrowserRouter, Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import { MarketingPageContainer } from 'src/features/MP/components/organisms/MarketingPageContainer';
import { MarketingLandingPage } from 'src/features/MP/components/templates/MarketingLandingPage';
import ContactPage from 'src/features/MP/components/templates/ContactPage';
import TermsPage from 'src/features/MP/components/templates/TermsPage';
import CookiePolicyPage from 'src/features/MP/components/templates/CookiePolicyPage';
import { PrivacyPolicyPage } from 'src/features/MP/components/templates/PrivacyPolicyPage';
import { DPAPage } from 'src/features/MP/components/templates/DPAPage';
import ServiceDescriptionPage from 'src/features/MP/components/templates/ServiceDescriptionPage';
import PricingPage from 'src/features/MP/components/templates/PricingPage';
import CompanyPage from 'src/features/MP/components/templates/CompanyPage';
import ResourcesPage from 'src/features/MP/components/templates/ResourcesPage';
import ProductsPage from 'src/features/MP/components/templates/ProductsPage';
import GettingStartedGuidePage from 'src/features/MP/components/templates/ResourcesPage/GettingStartedGuidePage';
import { PricingPlansPage } from 'src/features/MP/components/templates/ResourcesPage/PricingPlansPage';
import InviteYourTeamPage from 'src/features/MP/components/templates/ResourcesPage/InviteYourTeamPage';
import TrackIssuesPage from 'src/features/MP/components/templates/ResourcesPage/TrackIssuesPage';
import WorkspaceSettingsPage from 'src/features/MP/components/templates/ResourcesPage/WorkspaceSettingsPage';
import HowIntegrationsWorkPage from 'src/features/MP/components/templates/ResourcesPage/HowIntegrationsWorkPage';
import CustomSetupPage from 'src/features/MP/components/templates/ResourcesPage/CustomSetupPage';
import FaqSupportPage from 'src/features/MP/components/templates/ResourcesPage/FaqSupportPage';
import { AccountCreationPage } from 'src/features/Signup/components/templates/AccountCreationPage';
import NowPage from 'src/features/MP/components/templates/NowPage';
import BlogPostPage from 'src/features/MP/components/templates/BlogPostPage';
import { SubprocessorsPage } from 'src/features/MP/components/templates/SubprocessorsPage';
import { SaasTermsPage } from 'src/features/MP/components/templates/SaasTerms';
import { UserTermsPage } from 'src/features/MP/components/templates/UserTerms';
import { TermsOfExchangePage } from 'src/features/MP/components/TermsOfExchange';

export const Landings = () => {
  return (
    <BrowserRouter>
      <MarketingPageContainer>
        <Routes>
          <Route path="/" element={<MarketingLandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/subprocessors" element={<SubprocessorsPage />} />
          <Route path="/dpa" element={<DPAPage />} />
          <Route
            path="/service-description"
            element={<ServiceDescriptionPage />}
          />
          <Route path="/saas-terms" element={<SaasTermsPage />} />
          <Route path="/user-terms" element={<UserTermsPage />} />
          <Route path="/terms-of-exchange" element={<TermsOfExchangePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route
            path="/resources/getting-started"
            element={<GettingStartedGuidePage />}
          />
          <Route
            path="/resources/pricing-plans"
            element={<PricingPlansPage />}
          />
          <Route
            path="/resources/invite-your-team"
            element={<InviteYourTeamPage />}
          />
          <Route path="/resources/track-issues" element={<TrackIssuesPage />} />
          <Route
            path="/resources/workspace-settings"
            element={<WorkspaceSettingsPage />}
          />
          <Route
            path="/resources/how-integrations-work"
            element={<HowIntegrationsWorkPage />}
          />
          <Route path="/resources/custom-setup" element={<CustomSetupPage />} />
          <Route path="/resources/faq-support" element={<FaqSupportPage />} />
          <Route path="/register" element={<AccountCreationPage />} />
          <Route path="/product" element={<ProductsPage />} />
          <Route path="/now" element={<NowPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </MarketingPageContainer>
    </BrowserRouter>
  );
};
